import { createSelector } from 'reselect'

import { idSelector } from 'selectors/current_user'

import { usersPageSelector } from '../selectors'

export const sliceSelector = createSelector(usersPageSelector, ({ active }) => active)
const changeRolePopupSelector = createSelector(sliceSelector, ({ changeRolePopup }) => changeRolePopup)
export const paginationSelector = createSelector(sliceSelector, ({ pagination }) => pagination)
export const isLoadingSelector = createSelector(sliceSelector, ({ isLoading }) => isLoading)

export const isChangeRolePopupOpenSelector = createSelector(
  changeRolePopupSelector,
  (changeRolePopup) => changeRolePopup.isOpen
)

export const changeRolePopupMembershipsSelector = createSelector(
  changeRolePopupSelector,
  (changeRolePopup) => changeRolePopup.memberships
)

export const isOwnershipWarningOpenSelector = createSelector(
  changeRolePopupSelector,
  (changeRolePopup) => changeRolePopup.isOwnershipWarningOpen
)

export const selectedMembershipsSelector = createSelector(
  sliceSelector,
  ({ selectedMemberships }) => selectedMemberships
)

export const selectedIdsSelector = createSelector(
  selectedMembershipsSelector,
  (selectedMemberships) => selectedMemberships.map(({ id }) => id)
)

export const selectedEntitiesCountSelector = createSelector(
  selectedMembershipsSelector,
  (selectedMemberships) => selectedMemberships.length
)

const selectedEntitiesCountOnCurrentPageSelector = createSelector(
  sliceSelector,
  selectedIdsSelector,
  ({ memberships }, selectedIds) => {
    const currentPageMembershipIds = memberships.map(({ id }) => id)

    return selectedIds.filter((id) => currentPageMembershipIds.includes(id)).length
  }
)

export const membershipsSelector = createSelector(
  sliceSelector,
  selectedIdsSelector,
  ({ memberships }, selectedIds) => memberships.map((entity) => ({
    ...entity,
    is_selected: selectedIds.includes(entity.id)
  }))
)

export const batchCheckboxStatusSelector = createSelector(
  idSelector,
  selectedEntitiesCountOnCurrentPageSelector,
  membershipsSelector,
  (currentUserId, selectedEntitiesCountOnCurrentPage, memberships) => {
    if (selectedEntitiesCountOnCurrentPage === 0) {
      return 'none'
    }
    const notDisabled = (membership) => !(membership.role === 'owner' || currentUserId === membership.user_id)
    if (selectedEntitiesCountOnCurrentPage === memberships.filter(notDisabled).length) {
      return 'all'
    }
    return 'some'
  }
)

export const filterTermSelector = createSelector(
  sliceSelector,
  ({ filter }) => filter
)

const removeUsersPopupSelector = createSelector(sliceSelector, ({ removeUserPopup }) => removeUserPopup)

export const isRemovePopupOpenSelector = createSelector(removeUsersPopupSelector, ({ isOpen }) => isOpen)
export const isRemovingLoadingSelector = createSelector(removeUsersPopupSelector, ({ status }) => status === 'loading')

export const membershipToRemoveSelector = createSelector(
  sliceSelector,
  removeUsersPopupSelector,
  ({ memberships }, { userId }) => (memberships.find((membership) => membership.user_id === userId))
)

export const isBatchRemovalSelector = createSelector(
  removeUsersPopupSelector,
  ({ isBatch }) => isBatch
)

export const sortFieldSelector = createSelector(sliceSelector, ({ sortField }) => sortField)
export const sortOrderSelector = createSelector(sliceSelector, ({ sortOrder }) => sortOrder)
export const isAddToGroupPopupOpenSelector = createSelector(sliceSelector, ({ addToGroupPopupOpen }) => addToGroupPopupOpen)
